// extracted by mini-css-extract-plugin
export default {"topBox":"styles_topBox__EQID5","mainTitle":"styles_mainTitle__vVYoe","textBox":"styles_textBox__3li6W","text":"styles_text__HLC2N"};